import React, { useState } from 'react';
import { mutateImageUrl } from '../../wordpress';
import TorsoTextOverlay from './TorsoTextOverlay';
import { selectSectionAndCategory, setActiveFilterButton } from '../../actions';
import Warning from './Warning';
import ProductWarningText from './Products/ProductWarningText';

const PreviewItem = ({ item, info, dispatch, onEdit, onRemove, isAccessoryItem, skintone, torsoOverlays }) => {
    const [showWarning, setShowWarning] = useState(false);
    const [showProductBackImage, setShowProductBackImage] = useState(false);
    const accessoryNoItem = !item && isAccessoryItem;
    let imgSrc = info.defaultImage;
    let productBackImage = null;

    if (item) {
        if (info.id === 'bodies') {
            const attr = item?.attributes?.title?.toLowerCase().replaceAll(' ', '');
            item.product.images.edges.forEach((image) => {
                if (attr) {
                    if (image.node.url.toLowerCase().includes(`/${attr}-back`)) {
                        productBackImage = image.node.url;
                    }
                } else {
                    if (image.node.url.toLowerCase().includes('-back')) {
                        productBackImage = image.node.url;
                    }
                }
            });
        } else if (item.productMatchAttr?.reverseImage?.reference?.image?.url) {
            productBackImage = mutateImageUrl(item.productMatchAttr?.reverseImage?.reference?.image?.url, 480, 480);
        }

        if (productBackImage && showProductBackImage) {
            imgSrc = productBackImage;
        } else if (item.attributes?.image?.url) {
            imgSrc = mutateImageUrl(item.attributes.image.url, 480, 480);
        } else if (item.productMatchAttr?.image?.url) {
            imgSrc = item.productMatchAttr?.image?.url;
        } else if (item.product?.featuredImage?.url) {
            imgSrc = item.product.featuredImage.url;
        }
    }

    return (
        <>
            <div
                className={`preview-item preview-item__${info.id} ${accessoryNoItem ? 'show-border' : ''} ${
                    !isAccessoryItem ? 'not-accessory' : ''
                } ${item ? 'has-item' : ''}`}
            >
                <ProductWarningText product={item?.product} />

                <div className="preview-item__button--container">
                    <button
                        type="button"
                        className={`preview-item__button ${
                            item ? 'preview-item__button--edit' : 'preview-item__button--add'
                        }`}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (item) {
                                onEdit(info.id, item.product.id);
                                dispatch(setActiveFilterButton(null));
                            } else {
                                dispatch(selectSectionAndCategory(info, null, skintone));
                                dispatch(setActiveFilterButton(null));
                            }

                            const browser = document.querySelector('.browser');
                            browser?.scrollIntoView({ behavior: 'smooth' });
                        }}
                    >
                        Edit
                    </button>

                    {item && productBackImage && (
                        <button
                            className="preview-item__button preview-item__button--rotate"
                            onClick={() => setShowProductBackImage((showProductBackImage) => !showProductBackImage)}
                        >
                            Rotate
                        </button>
                    )}
                </div>

                <button
                    className={`preview-item__button preview-item__button--item ${accessoryNoItem ? 'vh' : ''}`}
                    onClick={() => {
                        dispatch(selectSectionAndCategory(info, null, skintone));
                        dispatch(setActiveFilterButton(null));

                        const browser = document.querySelector('.browser');
                        browser.scrollIntoView({ behavior: 'smooth' });
                    }}
                >
                    {imgSrc && <img className="preview-item__image" src={imgSrc} alt="" />}
                    {info.id === 'bodies' && (
                        <>
                            <TorsoTextOverlay
                                minFontSize={5}
                                showBackImage={showProductBackImage}
                                productTags={item?.product?.tags}
                            />
                            {torsoOverlays && !showProductBackImage && item && (
                                <>
                                    <img
                                        className="preview-item__image overlay handImage"
                                        src={torsoOverlays.handImage}
                                        alt=""
                                    />
                                    <img
                                        className="preview-item__image overlay torsoOverlayImage"
                                        src={torsoOverlays.torsoOverlayImage}
                                        alt=""
                                    />
                                </>
                            )}
                        </>
                    )}
                </button>

                <div className="preview-item__button--container remove">
                    <button
                        type="button"
                        className={`preview-item__button preview-item__button--remove ${
                            item ? '' : 'preview-item__button--vh'
                        } ${accessoryNoItem ? 'vh' : ''}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            setShowWarning(true);
                        }}
                    >
                        Remove
                    </button>
                </div>
            </div>

            {showWarning && (
                <Warning
                    actionConfirm={() => {
                        setShowWarning(false);
                        onRemove(info.id);
                    }}
                    actionDeny={() => {
                        setShowWarning(false);
                    }}
                    warningText="Are you sure that you'd like to remove this item?"
                />
            )}
        </>
    );
};

export default PreviewItem;
